module.exports = "https://qp-assets.quero.com/assets/images/landing/blue-oval.svg?3655af43f8d54fdf775b27d7a9e0b4d3";